import { render, staticRenderFns } from "./discarded.vue?vue&type=template&id=318d4f8c&"
import script from "./discarded.vue?vue&type=script&lang=js&"
export * from "./discarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports